/**
 * * Flattens a nested columns structure into a single-level array of columns.
 * @param {*} columns 
 * @returns 
 */
export function flattenColumns(columns) {
    const result = [];
    if (!columns) return result;


    columns.forEach((col) => {
        if (col.columns && Array.isArray(col.columns)) {
            let column = { ...col };
            delete column.columns; // remove nested columns to avoid duplication in result
            result.push(column); // add parent column (if it has a caption or is needed for export)
            result.push(...flattenColumns(col.columns));
        } else {
            result.push(col);
        }
    });


    return result;
}